import { IFilterOrderTable, IOrderPagination, IOrderTable } from "@/types/components/orderReport";
import { createSelector, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../store";

const today = new Date();
const orderTableInitial: IOrderTable[] = []

const orderFilterTableInitial: IFilterOrderTable = {
    dueDate: [],
    fulfillment: [],
    location: [],
    orderStatus: [],
    customDate: {
        start: today.toLocaleDateString(),
        end: today.toLocaleDateString(),
    },
    tab: 1,
}

const orderPaginationInitial:IOrderPagination = {
    page: 1,
    perPage: 25,
    totalItems: 0,
    hasNext: true,
    hasPreviouse: false,
    totalRecord: 1
}


const initialState = {
    orderTableSettings: orderTableInitial,
    orderFilterTableSettings: orderFilterTableInitial,
    orderPaginationSettings: orderPaginationInitial
}

const orderSlice = createSlice({
    name: 'order',
    initialState,
    reducers: {
        handleSaveOrderTableSettings: (state, action: PayloadAction<IOrderTable[]>) => {
            state.orderTableSettings = action.payload;
        },
        handleSaveOrderFilterTableSettings: (state, action: PayloadAction<Partial<IFilterOrderTable>>) => {
            state.orderFilterTableSettings = { ...state.orderFilterTableSettings, ...action.payload };
        },
        handleSaveOrderPaginationSettings: (state, action: PayloadAction<Partial<IOrderPagination>>) => {
            state.orderPaginationSettings = { ...state.orderPaginationSettings, ...action.payload };
        },
    }
})

export const orderTableSettingSelector = createSelector(
    (state: RootState) => state.order,
    (state) => state.orderTableSettings,
);

export const orderFilterSettingSelector = createSelector(
    (state: RootState) => state.order,
    (state) => state.orderFilterTableSettings,
);

export const orderPaginationSettingSelector = createSelector(
    (state: RootState) => state.order,
    (state) => state.orderPaginationSettings,
);


export const {
    handleSaveOrderTableSettings,
    handleSaveOrderFilterTableSettings,
    handleSaveOrderPaginationSettings
} = orderSlice.actions

export default orderSlice;